import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme, Colors } from '@app/theme';
import { useTranslation } from 'react-i18next';

export type ChipColor = Colors;

const useStyles = createUseStyles((theme: Theme) => ({
  label: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
    marginBottom: theme.marginBase,
  },
}));

interface Props {
  label: string;
  className?: string;
  children: React.ReactNode;
}

export const LabeledSection: React.FC<Props> = ({
  label,
  children,
  className,
}) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  return (
    <div className={className}>
      <p className={classes.label}>{t(label)}</p>
      {children}
    </div>
  );
};
